import { useEffect, useState, useSyncExternalStore } from "react";
import { useLocale } from "@/i18n/useLocale";
import { getStoredConsent, storeConsent } from "@/services/cookieConsent";
import { initClarity } from "@/services/clarity";
import { updateConsent } from "@/services/gtag";
import "./CookieConsent.css";

// No hay nada externo a lo que suscribirse -el valor solo cambia por
// nuestros propios clicks, manejados abajo con setDismissed-, asi que el
// subscribe de useSyncExternalStore no hace nada.
const noopSubscribe = () => () => {};

/**
 * Aviso de cookies: popup chico, no bloqueante, que se muestra una sola vez
 * por navegador hasta que el visitante elige.
 *
 * useSyncExternalStore (no useEffect + setState) para leer localStorage: la
 * lectura real solo pasa en el cliente (getSnapshot), mientras que el
 * prerender en Node -sin localStorage- usa getServerSnapshot, que siempre
 * devuelve "ya hay consentimiento" para que el HTML pre-renderizado nunca
 * muestre el aviso y no haya mismatch de hidratacion.
 */
function CookieConsent() {
  const { t } = useLocale();
  const [dismissed, setDismissed] = useState(false);

  const hasStoredConsent = useSyncExternalStore(
    noopSubscribe,
    () => getStoredConsent() !== null,
    () => true,
  );

  const visible = !hasStoredConsent && !dismissed;

  // Avisa al resto de la pagina que el aviso esta a la vista: el boton flotante
  // de WhatsApp se aparta mientras tanto (ver FloatingButtons.css).
  useEffect(() => {
    document.documentElement.classList.toggle("has-cookie-banner", visible);
    return () => document.documentElement.classList.remove("has-cookie-banner");
  }, [visible]);

  if (!visible) return null;

  const handleAccept = () => {
    storeConsent("accepted");
    initClarity();
    updateConsent(true);
    setDismissed(true);
  };

  const handleDecline = () => {
    storeConsent("declined");
    updateConsent(false);
    setDismissed(true);
  };

  return (
    <div className="cookie-consent" role="region" aria-label={t.cookieConsent.label}>
      <p className="cookie-consent__text">{t.cookieConsent.message}</p>
      <div className="cookie-consent__actions">
        <button type="button" className="cookie-consent__decline" onClick={handleDecline}>
          {t.cookieConsent.decline}
        </button>
        <button type="button" className="cookie-consent__accept" onClick={handleAccept}>
          {t.cookieConsent.accept}
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
